module.exports = {
      id: "follow-youtube-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#follow-youtube",
      toString: function () {
        return this.url;
      }
    }